import { useSearchParam } from 'react-use';

export interface UseTestingVariables {
  testingEnabled: boolean;
}

export const useTestingVariables = (): UseTestingVariables => {
  const testingMode = useSearchParam('testingMode');

  return { testingEnabled: testingMode?.toLocaleLowerCase() === 'true' };
};
